import { render } from "./index.vue?vue&type=template&id=f1edf2f8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=f1edf2f8&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1edf2f8"],['__file',"src/views/settings/weapp/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f1edf2f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f1edf2f8', __exports__)) {
    console.log('reload')
    api.reload('f1edf2f8', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=f1edf2f8&scoped=true", () => {
    console.log('re-render')
    api.rerender('f1edf2f8', render)
  })

}


export default __exports__